import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { useTranslation } from 'react-i18next';

import { restorePassword } from '../../../action/AccountActions';
import GreyHeader from '../../GreyHeader'
import CustomButton from '../../CustomButton';

const AccountPasswordRecoveryContainer = (props) => {
    const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountPasswordRecoveryContainer' });
    const { user, toggleLoader } = props;

    const sendForm = (e) => {
        e.preventDefault();

        toggleLoader(true);

        restorePassword(user.user.email).then((res, err) => {
            toggleLoader(false);

            toastr.success('', t('passwordChanged'));
        })
            .catch((error) => {
                toggleLoader(false);

                toastr.error(t('unableChangePassword'));
            });
    };

    return (
        <>
            <GreyHeader title={t('titlePasswordRecovery')} hideSubtitle />

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <form>
                    <div className="form-group">
                        <label className="control-label" style={{ fontSize: '20px' }}>{t('labelEmail')} {user.user.email}</label>
                    </div>

                    <div className="form-group" style={{ fontSize: '16px' }}>
                        {t('textBlock_1')}<br />
                        {t('textBlock_2')}
                    </div>

                    <div className="form-group">
                        <CustomButton variant='primary' onClick={sendForm}>{t('btnReset')}</CustomButton>
                    </div>
                </form>
            </div>
        </>
    );
};

export default connect(
    state => ({
        user: state.user.user
    }),
    dispatch => ({
        toggleLoader: (show) => {
            dispatch({ type: 'TOGGLE_LOADER', payload: show });
        }
    })
)(AccountPasswordRecoveryContainer);
